import { Route, Switch } from 'react-router-dom';
import { LoadComponent } from '@yooink/youtils/es/LoadComponent';
import MenuManager from '@yooink/youtils/es/MenuManager';
import withErrorCatcher from '@yooink/youtils/es/WithErrorCatcher';
import { addPropsToComponent } from '@yooink/youtils/es/AddPropsToComponent';
import PropTypes from 'prop-types';

const List = LoadComponent(() => import('./List'));

MenuManager.RegisterItem({
	key: 'SSOAuthRequest',
	path: '/ssoauthrequest',
	name: 'SSOAuthRequest'
});

const SSOAuthRequestRoute = (props) => {
	const basePath = props.path || '/ssoauthrequest';
	const getPath = (path = '') => `${basePath}${path}`;

	const chain = (component) => withErrorCatcher(addPropsToComponent({
		basePath
	}, component));

	return (
		<>
			<Route
				exact
				path={getPath()}
				component={chain(List)}
			/>
		</>
	);
};

SSOAuthRequestRoute.propTypes = {
	path: PropTypes.string
};

export { SSOAuthRequestRoute };
